import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const AnimalsGraveIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M16.3652 18.084C16.3652 17.8502 16.1731 17.6604 15.9363 17.6604H13.7134V9.61885H17.999V6.23262H13.7134V2H10.2847V6.23262H6V9.61885H10.2856V17.6604H8.0627C7.82593 17.6604 7.63378 17.8502 7.63378 18.084V19.1426H6.00005V22H18L17.9991 19.1417H16.3654L16.3652 18.084Z'
                fill='currentColor'
            />
        </>
    ),
})

AnimalsGraveIcon.displayName = 'AnimalsGraveIcon'
